import React, { useState } from "react";
import DataTable from "react-data-table-component";
import './Table2.css'
import SinglePagenation from "../general/pagination/SinglePagenation";

function Table2({ col, roo }) {
  const [pageNumber, setPageNumber] = useState(0);
  const productPerPage = 5;
  const pagesVisited = pageNumber * productPerPage;
  const displayArr = roo.slice(
    pagesVisited,
    pagesVisited + productPerPage
  );

  const pageCount = Math.ceil(roo.length / productPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: `var(--light)`
      }
    },
    rows: {
      style: {
        backgroundColor: `var(--light)`,
        color: `var(--text-color)`,
        marginTop: "5px",
        marginBottom: "5px"
      }
    },
    headCells: {
      style: {
        backgroundColor: `var(--background-head-table)`,
        color: `var(--text-color)`,
        fontSize: "14px",
        fontWeight: 'bold'
      }
    },
  };

  const NoDataComponent = () => (
    <div style={{ color: `var(--title-color)`, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px', width: '100%', backgroundColor: `var(--light)`, padding: "10px" }}>There are no records to display</div>
  );

  return (
    <div style={{ backgroundColor: `var(--light)`, marginBottom: "10px", overflow: "auto",minHeight: "300px" }} >
      <DataTable
        columns={col}
        data={displayArr}
        onSelectedRowsChange={() => { }}
        customStyles={customStyles}
        noDataComponent={<NoDataComponent />}
        className="custom-table"
        noHeader
      />
      {pageCount > 1 && (
        <>
          <div className="pagination">
            <SinglePagenation
              pageCount={pageCount}
              changePage={changePage}
            />
          </div>
          <br></br>
        </>
      )}
    </div>
  );
}

export default Table2;